export const PRODUCT_SECTION = "PRODUCT_SECTION";
export const productSection = (data) => {
    return {
        type: PRODUCT_SECTION,
        payload:data
    }
}